<template>
    <error-content
        :src="src"
        code="404"
        desc="Oh~~您的页面好像飞走了~"
    />
</template>

<script>
import errorContent from './error-content.vue';

export default {
    name: 'Error404',
    components: {
        errorContent,
    },
    data() {
        return {
            src: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/common/404.png',
        };
    },
};
</script>
